<template>
  <RevTag class="mb-8" :label="i18n(translations.toDo)" variant="warning" />

  <h2 class="heading-2 mb-8">
    {{ i18n(translations.noDsaTitle) }}
  </h2>

  <div class="body-1 mb-16">
    {{ i18n(translations.noDsaSubtitle) }}
  </div>

  <RevButton variant="primary" @click="$emit('add')">
    {{ i18n(translations.getStarted) }}
  </RevButton>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevTag } from '@ds/components/Tag'

import translations from './EmptyBlockContent.translations'

const i18n = useI18n()

defineEmits<{
  add: []
}>()
</script>
